import { orderBy, toNumber } from "lodash";
import { useMemo } from "react";
import { useAccountOrganizationsQuery } from "@/features/organization/graphql/generated";
import { useViewer } from "@/features/profile/hooks/useViewer";

export const useAccountOrganizations = (accountId?: number) => {
  const { viewer } = useViewer();
  const defaultAccountId = toNumber(viewer.default_account_id);
  const { data, loading } = useAccountOrganizationsQuery({
    variables: {
      account_id: accountId || defaultAccountId,
    },
    skip: !accountId && !defaultAccountId,
  });

  const organizations = useMemo(() => {
    if (!data?.organizations) return [];

    return orderBy(data.organizations, "name", ["asc"]);
  }, [data]);

  return {
    loading,
    organizations,
  };
};
